export const isSinglePitch = (
  singlePitchMaybe: number | [number, number]
): singlePitchMaybe is number => {
  return typeof singlePitchMaybe === "number";
};
